import { useDispatch } from "react-redux";

import HTTP_REQUEST from "@/utils/http";
import url from "@/utils/url";
import { formatToSelectCustom } from "@/utils/Utils";
import { API_CANAL } from '@/utils/consts';
import { changeGlobalState } from "@/redux/actions/global";
import helpers from "@/utils/helpers";

export const useUbigeoService = () => {

	const dispatch = useDispatch();

	const getDepartment = async (data) => {
		try {
			const { response: { payload } } = await HTTP_REQUEST.postWitchTrace(
				url.obtenerDepartamentos,
				data,
				'UTILITARIOS',
				API_CANAL
			);
			const newOrder = payload.filter(({ descripcionDepartamento }) => descripcionDepartamento !== 'LIMA');
			const lima = payload.find(({ descripcionDepartamento }) => descripcionDepartamento === 'LIMA');

			const departamentoFormated = formatToSelectCustom([lima, ...newOrder], {
				value: "ideDepartamento",
				text: "descripcionDepartamento",
				label: "descripcionDepartamento",
			});

			return departamentoFormated;
		} catch (error) {
			dispatch(changeGlobalState(4));
			helpers.sendTagError(error, url.obtenerDepartamentos);
		}
	};

	const getProvince = async (data) => {
		try {
			const { response: { payload } } = await HTTP_REQUEST.postWitchTrace(
				url.obtenerProvincias,
				data,
				'UTILITARIOS',
				API_CANAL
			);
			const provinciaFormated = formatToSelectCustom(payload, {
				value: "ideProvincia",
				text: "descripcionProvincia",
				label: "descripcionProvincia",
			});
			return provinciaFormated;
		} catch (error) {
			dispatch(changeGlobalState(4));
			helpers.sendTagError(error, url.obtenerProvincias);
		}
	};

	const getDistrict = async (data) => {
		try {
			const { response: { payload } } = await HTTP_REQUEST.postWitchTrace(
				url.obtenerDistritos,
				data,
				'UTILITARIOS',
				API_CANAL
			);
			const distritoFormated = formatToSelectCustom(payload, {
				value: "ideDistrito",
				text: "descripcionDistrito",
				label: "descripcionDistrito",
			});
			return distritoFormated;
		} catch (error) {
			dispatch(changeGlobalState(4));
			helpers.sendTagError(error, url.obtenerDistritos);
		}
	};

	return {
		getDepartment,
		getProvince,
		getDistrict
	}
};